import { Component, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
    selector: 'app-product-animation',
    templateUrl: './product-animation.component.html',
    styleUrls: ['./product-animation.component.scss'],
    standalone: true,
    imports: [LottieComponent],
})
export class ProductAnimationComponent implements OnInit {
  options: AnimationOptions = {
    path: 'https://assets10.lottiefiles.com/packages/lf20_eds0nlhs.json'
  }
  viewAnimation = true;
  constructor() { }

  ngOnInit() {
    this.viewAnimation = true;
  }
  onLoopComplete() {
    this.viewAnimation = false;
  }

}
